<div class="card">
    <div class="card-body">
        <a [routerLink]="'/offers/' + data.id">{{ data.id }}</a>
    </div>
</div>
  